import { SiFacebook, SiInstagram, SiWhatsapp, SiYoutube } from "@icons-pack/react-simple-icons";
import type { ComponentType, SVGProps } from "react";
import { NEXT_PUBLIC_WHATSAPP_PHONE } from "../config/env.client";

export interface SocialLink {
  name: string;
  href: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}

export const SOCIAL_LINKS: SocialLink[] = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/people/EtheraGuru/61573938274958",
    icon: SiFacebook,
  },
  { name: "YouTube", href: "https://www.youtube.com/@etheraguru", icon: SiYoutube },
  { name: "Instagram", href: "https://www.instagram.com/etheraguru_official", icon: SiInstagram },
  ...(NEXT_PUBLIC_WHATSAPP_PHONE
    ? [
        {
          name: "WhatsApp",
          href: `https://wa.me/${NEXT_PUBLIC_WHATSAPP_PHONE}`,
          icon: SiWhatsapp as ComponentType<SVGProps<SVGSVGElement>>,
        },
      ]
    : []),
];
